const BASE_FONT_SIZE = 16;

export type Scale =
  | 0
  | 1
  | 2
  | 2.5
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 8.75
  | 10
  | 11
  | 12
  | 12.25
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 24
  | 26
  | 28
  | 29
  | 30
  | 31
  | 32
  | 34
  | 36
  | 38
  | 40
  | 44
  | 45
  | 48
  | 52
  | 55
  | 56
  | 60
  | 64
  | 70
  | 72
  | 76
  | 80
  | 88
  | 96
  | 104
  | 120
  | 130
  | 144
  | 153
  | 160
  | 168
  | 175
  | 180
  | 188
  | 195
  | 200
  | 224
  | 245
  | 260
  | 288
  | 232
  | 296
  | 300
  | 313
  | 316
  | 336
  | 352
  | 360
  | 370
  | 380
  | 390
  | 400
  | 416
  | 420
  | 448
  | 450
  | 462
  | 472
  | 480
  | 492
  | 496
  | 512
  | 536
  | 578
  | 636
  | 650
  | 712
  | 720
  | 752
  | 776
  | 862
  | 864
  | 875
  | 878
  | 1040
  | 1104
  | 1120
  | 1170
  | 1176
  | 1234;

export function rem(
  scale: Scale,
  allowPixel = false,
): `${number}rem` | `${number}px` {
  if (allowPixel) {
    return `${scale}px`;
  }
  return `${scale / BASE_FONT_SIZE}rem`;
}
